import { defineStore } from "pinia";
import type { IEnvironmentConfig } from "./common/types";

interface IEnvironmentConfigStoreState {
  environmentConfig: IEnvironmentConfig;
}

export const useEnvironmentConfigStore = defineStore("environmentConfig", {
  state: (): IEnvironmentConfigStoreState => ({
    environmentConfig: {
      authorsPerPage: 10,
      articlesPerPage: 10,
      isCallForPapersVisible: false,
      isImpactMetricsVisible: true,
      isResearchTopicImportantNoteVisible: true,
      showRtImpactTab: true,
      showInstitutionsBlock: true,
      minimumRtDownloadsCount: 10,
      isManuscriptButtonVisible: undefined
    }
  }),
  getters: {
    getConfig: (state) => () => state.environmentConfig
  },
  actions: {
    fetchValidatedConfig() {
      const {
        isCallForPapersVisible,
        isImpactMetricsVisible,
        isResearchTopicImportantNoteVisible,
        showRtImpactTab,
        showInstitutionsBlock,
        minimumRtDownloadsCount,
        authorsPerPage,
        articlesPerPage,
        isManuscriptButtonVisible
      } = useRuntimeConfig().public;

      this.environmentConfig = {
        authorsPerPage: parseInt(authorsPerPage),
        articlesPerPage: parseInt(articlesPerPage),
        isCallForPapersVisible: useEnvBoolean(isCallForPapersVisible),
        isImpactMetricsVisible: useEnvBoolean(isImpactMetricsVisible),
        isResearchTopicImportantNoteVisible: useEnvBoolean(
          isResearchTopicImportantNoteVisible
        ),
        showRtImpactTab: useEnvBoolean(showRtImpactTab),
        showInstitutionsBlock: useEnvBoolean(showInstitutionsBlock),
        isManuscriptButtonVisible: useEnvBoolean(isManuscriptButtonVisible),
        minimumRtDownloadsCount: parseInt(minimumRtDownloadsCount) ?? 10
      };
    }
  }
});
